import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_vat_summary_reports } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollNumber from "antd/es/badge/ScrollNumber";
import ScrollWrapper from "../../../Componets/ScrollWrapper";

const VatSummaryReport = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [role, setRole] = useState("");

  const headers = {
    name: "Invoices",
    components: [
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: new Date(),
          end: new Date(),
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "VAT Summary",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_vat_summary_reports(data);


      if (products?.status) {
        setBody(products?.data?.vatSummary);
        setRole(products?.data?.role)
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const downloadCSV = () => {
    if (!body) {
      toast.error("No data available to download");
      return;
    }

    try {
      const header = ["Category", "Taxable Amount", "VAT Amount", "Total With VAT"];

      const rows = [
        ["Sales VAT", body?.sales?.taxable_amount || "0.000", body?.sales?.vat_amount || "0.000", body?.sales?.total_with_vat || "0.000"],
        ["Purchase VAT", body?.purchases?.taxable_amount || "0.000", body?.purchases?.vat_amount || "0.000", body?.purchases?.total_with_vat || "0.000"],
        ["NET VAT PAYABLE", "", "", body?.net_vat_payable || "0.000"]
      ];

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `VAT_Summary_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast.success("CSV downloaded successfully");

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body) {
      toast.error("No data available to download");
      return;
    }

    try {
      const doc = new jsPDF();
      registerCairoFont(doc);
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");

      doc.setFontSize(18);
      doc.text("VAT Summary Report", pageWidth / 2, 18, { align: "center" });

      const now = new Date();
      const formattedDate = now.toLocaleDateString("en-GB");
      const formattedTime = now.toLocaleTimeString();
      doc.setFontSize(10);
      doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

      doc.setFontSize(12);
      doc.text("SALES VAT", 14, 40);

      autoTable(doc, {
        startY: 45,
        head: [["Taxable Amount", "VAT Amount", "Total With VAT"]],
        body: [[
          body?.sales?.taxable_amount || "0.000",
          body?.sales?.vat_amount || "0.000",
          body?.sales?.total_with_vat || "0.000"
        ]],
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },

        theme: 'grid',
      });

      const salesTableEnd = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("PURCHASE VAT", 14, salesTableEnd);

      autoTable(doc, {
        startY: salesTableEnd + 5,
        head: [["Taxable Amount", "VAT Amount", "Total With VAT"]],
        body: [[
          body?.purchases?.taxable_amount || "0.000",
          body?.purchases?.vat_amount || "0.000",
          body?.purchases?.total_with_vat || "0.000"
        ]],
        theme: 'grid',
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },

      });

      const purchaseTableEnd = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("NET VAT PAYABLE", 14, purchaseTableEnd);

      autoTable(doc, {
        startY: purchaseTableEnd + 5,
        head: [["TOTAL"]],
        body: [[body?.net_vat_payable || "0.000"]],
        theme: 'grid',
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },

      });

      doc.save(`VAT_Summary_Report_${formattedDate.replace(/\//g, '_')}.pdf`);
      toast.success("PDF downloaded successfully");

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF file");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        
          <div className="mt-4">
            <div className="text-right flex gap-3 justify-end">
              <Button
                className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                type="primary"
                onClick={downloadCSV}
              >
                Download CSV
              </Button>

               <ReactToPrint
                           trigger={() => (
             
                             <Button
                               className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                               type="primary"
                             >
                               Download PDF
                             </Button>
                           )}
                           content={() => componentRef}
                           pageStyle={`
                                     @page {
                                       size: landscape;
                                       margin: 10mm;
                                     }
                       
                                     @media print {
                                       tfoot {
                                         position: static !important;
                                         bottom: auto !important;
                                       }
                                       thead { 
                                         display: table-header-group !important;
                                       }
                                       tfoot {
                                         display: table-row-group !important;
                                       }
                                     }
                       
                                       table {
                                       border-collapse: collapse;
                                       width: 100%;
                                     }
                                     th, td {
                                       border: 1px solid #ddd;
                                       padding: 6px;
                                     }
                                     th {
                                       background-color: #f4f4f4;
                                     }
                                   `}
                         />
            </div>
          </div>

          <ScrollWrapper>
          <div ref={(el) => (componentRef = el)}>
            <div>
              <div className="text-medium py-2">SALES VAT</div>
              <table className="w-full bg-white">
                <thead className="text-gray-500">
                  <tr>
                    <td className="border p-4">Taxable&nbsp;Amount</td>
                    <td className="border p-4">Vat&nbsp;Amount</td>
                    <td className="border p-4 text-right">
                      Total&nbsp;With&nbsp;Vat
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-4">{body?.sales?.taxable_amount}</td>
                    <td className="border p-4">{body?.sales?.vat_amount}</td>
                    <td className="border p-4 text-right">
                      {body?.sales?.total_with_vat}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <div className="text-medium py-2">Purchase VAT</div>
              <table className="w-full bg-white">
                <thead className="text-gray-500">
                  <tr>
                    <td className="border p-4">Taxable&nbsp;Amount</td>
                    <td className="border p-4">Vat&nbsp;Amount</td>
                    <td className="border p-4 text-right">
                      Total&nbsp;With&nbsp;Vat
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-4">
                      {body?.purchases?.taxable_amount}
                    </td>
                    <td className="border p-4">{body?.purchases?.vat_amount}</td>
                    <td className="border p-4 text-right">
                      {body?.purchases?.total_with_vat}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <div className="text-medium py-2">NET VAT PAYABLE</div>
              <table className="w-full bg-white">
                <thead className="text-gray-500">
                  <tr>
                    <td className="border p-4 text-medium text-black">TOTAL</td>
                    <td className="border p-4 text-medium text-black text-right">
                      {body?.net_vat_payable}
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default VatSummaryReport;